import { useCallback } from "react";
import { makeStyles } from "tss-react/mui";
import GradientActions from "actions/GradientActions";
import { reverseArray } from "services/UtilsService";
import {
  useTheme
} from '@mui/material';
const useStyles = makeStyles()({
    svg: {
        border: "1px solid #f0f0f0",
    },
    text: {
        lineHeight: 1.43,
        fontSize: 8,
        display: "inline-block",
        textAlign: "left",
    },
    smallText: {
        lineHeight: 1.43,
        fontSize: 6,
        display: "inline-block",
        textAlign: "left",
    },
});

function decimate(array: any, maxitem: number) {
    let skip: number = array.length / maxitem;
    if (skip < 1) skip = 1;
    let result: any = [];
    for (let i: number = 0; i < array.length; i += skip) {
        result.push((i / array.length) * 100);
    }
    return result;
}

type IProps = {
    width: number;
    height: number;
    source: any;
    histogram: any;
    method: number;
    showLabels?: boolean;
    min: number;
    max: number;
};

export default function Histogram(props: IProps) {
    const { classes } = useStyles();
    var { width, height, source, histogram, method, showLabels, min, max } = props;
    const scale = 100;
    const division = 10;
    const len = histogram.length;
    const spacing = len < 20 ? 5 : 1;
    const barWidth = (width - spacing * len) / len;
    const theme = useTheme();

    if (!min || typeof min === "undefined") {
        min = 0;
    }
    if (typeof max === "undefined") {
        max = 10;
    }
    var span = max - min;
    var colors: any, gradients: any;
    switch (method) {
        case 0:
        case 1:
            gradients = GradientActions.getLayerGradient(source);
            break;
        case 2:
            gradients = GradientActions.getQuantileGradient(histogram, source);
            break;
        case 3:
            gradients = GradientActions.getJenksGradient(histogram, source);
            break;
    }
    var defaultGradient = "rgb(255,165,0)";
    if (typeof gradients === "undefined") {
        colors = new Array(100);
        colors.fill("rgb(255,165,0)");
    } else {
        colors = [...gradients];
        if (colors && colors[0]) {
            defaultGradient = colors[0]["color"];
            colors = reverseArray(colors);
        }
    }
    var getBarColor = useCallback(
        (index: number) => {
            if (typeof colors[0] === "object") {
                var value = min + (index / len) * span;
                var gradient = colors.find((gradient: any) => {
                    return value > gradient.value;
                });
                var color;
                if (!gradient) {
                    color = defaultGradient;
                } else {
                    color = gradient["color"];
                }
                return color;
            } else {
                return colors[index];
            }
        },
        [colors, defaultGradient, len, span, min]
    );
    return (
        <div>
            {len > 0 ? (
                <div style={{ width, height }}>
                    <svg width={width} height={height}>
                        <rect
                            fill="transparent"
                            strokeWidth="0.7"
                            height={height - 20}
                            width={width}
                            y="0"
                            x="0"
                            stroke="#E6E6E6"
                        />
                        <g transform="translate(0,-20)">
                            {histogram.map((dataPoint: number, index: number) => (
                                <g key={"data-" + index}>
                                    <g>
                                        <rect
                                            width={barWidth}
                                            height={dataPoint * scale}
                                            fill={getBarColor(index)}
                                            x={index * (barWidth + spacing)}
                                            y={height - dataPoint * scale}
                                        >
                                            {dataPoint.toFixed(2)}
                                        </rect>
                                    </g>
                                </g>
                            ))}
                        </g>
                        <g transform="translate(0,70)" fill="none">
                            {showLabels
                                ? decimate(histogram, 10).map((dataPoint: number, index: number) => (
                                      <g key={"data-" + index}>
                                          <g
                                              className="tick"
                                              opacity="1"
                                              transform={"translate(" + (dataPoint / 100) * width + " , 0)"}
                                          >
                                              <line stroke="silver" y2="6"></line>
                                              <text
                                                  fill={theme.palette.text.secondary}
                                                  y="9"
                                                  x={index === 0 ? 0 : -6}
                                                  dy="0.71em"
                                                  className={
                                                      (min + (index / division) * span).toFixed(2).length > 6
                                                          ? classes.smallText
                                                          : classes.text
                                                  }
                                              >
                                                  {(min + (index / division) * span).toFixed(2)}
                                              </text>
                                          </g>
                                      </g>
                                  ))
                                : ""}
                        </g>
                    </svg>
                </div>
            ) : (
                ""
            )}
        </div>
    );
}
